import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-overlock",
  "use": "icon-overlock-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-overlock\"><defs><style type=\"text/css\"></style></defs><path d=\"M331.072 692.928a256 256 0 1 1 361.856 0l120.768 120.768a426.666667 426.666667 0 1 0-603.392 0z\" p-id=\"5834\" data-spm-anchor-id=\"a313x.7781069.0.i21\" class=\"selected\" fill=\"#becbdc\" /><path d=\"M512 938.666667a425.194667 425.194667 0 0 0 134.848-22.101334L512 512l-134.848 404.565333A425.194667 425.194667 0 0 0 512 938.666667z\" p-id=\"5835\" data-spm-anchor-id=\"a313x.7781069.0.i22\" class=\"selected\" fill=\"#becbdc\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/overlock.svg
// module id = 4lLv
// module chunks = 103